"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTodayDateFormatted = exports.getUserTimeZone = exports.timeAgo = exports.currentTimestamp = exports.currentTimestampZeroed = exports.isValidDate = exports.isValidDatetime = exports.toISO8601 = exports.timestampToHHDDAMPM = exports.removeTimeFromUnixTimestamp = exports.timestampToMMDDYYYY = exports.dateToYYYYMMDDHHMMSS = exports.cleanupPropertyName = exports.capitalizeAllWords = exports.capitalizeFirstLetter = void 0;
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
exports.capitalizeFirstLetter = capitalizeFirstLetter;
function capitalizeAllWords(string) {
    return string
        .split(' ')
        .map(function (word) { return capitalizeFirstLetter(word); })
        .join(' ');
}
exports.capitalizeAllWords = capitalizeAllWords;
function cleanupPropertyName(string) {
    return capitalizeAllWords(string.replace(/_/g, ' '));
}
exports.cleanupPropertyName = cleanupPropertyName;
function dateToYYYYMMDDHHMMSS(date, timeZone) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (timeZone === void 0) { timeZone = 'UTC'; }
    var options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: timeZone,
    };
    var formattedDate = new Intl.DateTimeFormat('en-US', options).formatToParts(date);
    var year = (_b = (_a = formattedDate.find(function (part) { return part.type === 'year'; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
    var month = (_d = (_c = formattedDate.find(function (part) { return part.type === 'month'; })) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '';
    var day = (_f = (_e = formattedDate.find(function (part) { return part.type === 'day'; })) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '';
    var hour = (_h = (_g = formattedDate.find(function (part) { return part.type === 'hour'; })) === null || _g === void 0 ? void 0 : _g.value) !== null && _h !== void 0 ? _h : '';
    var minute = (_k = (_j = formattedDate.find(function (part) { return part.type === 'minute'; })) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '';
    var second = (_m = (_l = formattedDate.find(function (part) { return part.type === 'second'; })) === null || _l === void 0 ? void 0 : _l.value) !== null && _m !== void 0 ? _m : '';
    return "".concat(year).concat(month).concat(day).concat(hour).concat(minute).concat(second);
}
exports.dateToYYYYMMDDHHMMSS = dateToYYYYMMDDHHMMSS;
function timestampToMMDDYYYY(timestamp) {
    var actualSystemTimezone = getUserTimeZone();
    var date = new Date(timestamp * 1000);
    var formattedDate = new Intl.DateTimeFormat('en-US', {
        timeZone: actualSystemTimezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);
    formattedDate = formattedDate.replace(/\//g, '-');
    return formattedDate;
}
exports.timestampToMMDDYYYY = timestampToMMDDYYYY;
var removeTimeFromUnixTimestamp = function (timestamp) {
    // Convert to milliseconds, round down to the start of the day, and convert back to seconds
    return Math.floor(timestamp / 86400) * 86400;
};
exports.removeTimeFromUnixTimestamp = removeTimeFromUnixTimestamp;
function timestampToHHDDAMPM(timestamp) {
    var date = new Date(timestamp * 1000);
    // Format the time part
    var formattedTime = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    }).format(date);
    return formattedTime;
}
exports.timestampToHHDDAMPM = timestampToHHDDAMPM;
function toISO8601(date) {
    var z = function (n) { return (n < 10 ? "0".concat(n) : "".concat(n)); };
    var offset = function (n) { return (n < 0 ? "-".concat(z(n * -1)) : "+".concat(z(n))); };
    var c = new Date(date);
    return "".concat(c.getUTCFullYear(), "-").concat(z(c.getUTCMonth() + 1), "-").concat(z(c.getUTCDate()), "T").concat(z(c.getUTCHours()), ":").concat(z(c.getUTCMinutes()), ":").concat(z(c.getUTCSeconds())).concat(offset(c.getTimezoneOffset() / 60), ":00");
}
exports.toISO8601 = toISO8601;
function isValidDatetime(str) {
    var date = new Date(str);
    // Check if the date object is valid
    return !isNaN(date.getTime());
}
exports.isValidDatetime = isValidDatetime;
function isValidDate(dateString, format) {
    if (format === void 0) { format = 'MM-dd-yyyy'; }
    var _a = format.split('-').map(function (part) {
        if (part === 'MM')
            return 0;
        if (part === 'dd')
            return 1;
        if (part === 'yyyy')
            return 2;
        return -1;
    }), monthIndex = _a[0], dayIndex = _a[1], yearIndex = _a[2];
    var parts = dateString.split('-');
    if (parts.length !== 3)
        return false;
    var year = parseInt(parts[yearIndex], 10);
    var month = parseInt(parts[monthIndex], 10);
    var day = parseInt(parts[dayIndex], 10);
    if (isNaN(year) || isNaN(month) || isNaN(day))
        return false;
    // Validate year, month, and day ranges
    if (year < 1 || month < 1 || month > 12 || day < 1)
        return false;
    var daysInMonth = new Date(year, month, 0).getDate(); // Get the number of days in the month
    return day <= daysInMonth;
}
exports.isValidDate = isValidDate;
function currentTimestampZeroed() {
    var date = new Date(Date.now());
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    return Math.floor(date.getTime() / 1000.0);
}
exports.currentTimestampZeroed = currentTimestampZeroed;
function currentTimestamp() {
    return Math.floor(Date.now() / 1000.0);
}
exports.currentTimestamp = currentTimestamp;
function timeAgo(timestamp) {
    var now = new Date().getTime();
    var createdDate = new Date(timestamp * 1000); // assuming the timestamp is in seconds
    var seconds = Math.floor((now - createdDate.getTime()) / 1000);
    var interval = seconds / 31536000; // years
    if (interval > 1) {
        var outInterval = Math.floor(interval);
        return outInterval === 1 ? '1 year ago' : "".concat(outInterval, " years ago");
    }
    interval = seconds / 2592000; // months
    if (interval > 1) {
        var outInterval = Math.floor(interval);
        return outInterval === 1 ? '1 month ago' : "".concat(outInterval, " months ago");
    }
    interval = seconds / 86400; // days
    if (interval > 1) {
        var outInterval = Math.floor(interval);
        return outInterval === 1 ? '1 day ago' : "".concat(outInterval, " days ago");
    }
    interval = seconds / 3600; // hours
    if (interval > 1) {
        var outInterval = Math.floor(interval);
        return outInterval === 1 ? '1 hour ago' : "".concat(outInterval, " hours ago");
    }
    interval = seconds / 60; // minutes
    if (interval > 1) {
        var outInterval = Math.floor(interval);
        return outInterval === 1 ? '1 minute ago' : "".concat(outInterval, " minutes ago");
    }
    return 'Just now';
}
exports.timeAgo = timeAgo;
function getUserTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
exports.getUserTimeZone = getUserTimeZone;
function getTodayDateFormatted() {
    var today = new Date();
    var day = String(today.getDate()).padStart(2, '0'); // Get the day and pad to 2 digits
    var month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    var year = today.getFullYear();
    return "".concat(day, "/").concat(month, "/").concat(year);
}
exports.getTodayDateFormatted = getTodayDateFormatted;
